<template>

  <el-row :gutter="5">
    <el-col :span="4"></el-col>
    <el-col :span="16"><h2 class="heading">All Interview (Media) List</h2></el-col>
    <el-col :span="4"></el-col>
  </el-row>

  <el-row :gutter="5">
    <el-col :span="18" style="padding-left:40px;">
        <span class="label">Status</span>
        <el-select v-model="status" placeholder="Select status" @change="selectStatus()" style="width:150px;" clearable>
            <el-option label="pending" value="pending"></el-option>
            <el-option label="approved" value="approved"></el-option>
        </el-select>
        <span class="label">Nature</span>
        <el-select v-model="type" placeholder="Select nature" @change="selectType()" style="width:150px;" clearable>
            <el-option v-for="t in allTypes" :key="t" :label="t" :value="t"></el-option>
        </el-select>
        <span class="label">Interviewee</span>
        <el-select v-model="interviewee" placeholder="Select interviewee" @change="selectInterviewee()" style="width:150px;" clearable>
            <el-option v-for="interview in allInterviewees" :key="interview" :label="interview" :value="interview"></el-option>
        </el-select>
        <span class="label">Creator</span>
        <el-select v-model="creator" placeholder="Select creator" @change="selectCreator()" style="width:150px;" clearable>
            <el-option v-for="creator in allCreators" :key="creator.id" :label="creator.fullname" :value="creator.id"></el-option>
        </el-select>
    </el-col>
    <el-col :span="6">
        <el-button style="margin-right:10px;" @click="$router.push('/log/myInterviewList')">
            <el-icon><Search/></el-icon> &nbsp; My Interview List</el-button>
    </el-col>
  </el-row>
  
  <el-table :data="interviewList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="activityDate" label="Activity date" align="center" width="130" sortable="custom" />
    <el-table-column prop="mediaName" label="Media name" width="200" sortable="custom"/>
    <el-table-column prop="type" label="Nature" width="200" sortable="custom"/>
    <el-table-column prop="city" label="City" sortable="custom" />
    <el-table-column prop="externalLead" label="External lead" width="200" sortable="custom" />
    <el-table-column prop="interviewer" label="Interviewer" width="180" sortable="custom"  />
    <el-table-column prop="interviewee" label="Interviewee" sortable="custom" width="120" />
    <el-table-column prop="pubDate" label="Publish date" width="130" sortable="custom" />
    <el-table-column prop="creatorName" label="Creator" sortable="custom" />
    <el-table-column prop="status" label="Status" sortable="custom" />
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.status=='pending' && global.hasRight('event-interview', 'approver')" 
                @click.prevent="$router.push('/log/viewInterview?code=' + scope.row.idMD5)" title="Approve" class="op">
                Approve
            </a>
            <el-icon v-else :size="16" @click="$router.push('/log/viewInterview?code=' + scope.row.idMD5)" style="cursor:pointer" 
                title="View details" class="op">
                <document />
            </el-icon>
            <el-icon :size="16" v-if="(scope.row.status=='pending'||scope.row.status=='rejected') && currentUser.id == scope.row.creator" 
                @click.prevent="$router.push('/log/editInterview?code=' + scope.row.idMD5)" title="Edit" class="op">
                <Edit/>
            </el-icon>
            <el-icon :size="16" v-if="scope.row.status=='pending' && currentUser.id == scope.row.creator" 
                @click="deleteInterview(scope.row.idMD5)" title="Delete"  class="op">
                <Delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :currentPage="page.currPage"
    @current-change="getInterviewList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Search, Delete, Edit } from '@element-plus/icons-vue'

export default {
    components: {
        Document,  Search, Delete, Edit
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            currentUser: null,
            allInterviewees: ["Rebecca", "David", "Laura", "Larry", "Chanyoung"],
            allCreators: [],
            allTypes: [],
            interviewee: null,
            type: null,
            creator: null,
            status: null,
            interviewList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "interview";
        this.currentUser = this.global.currentUser;
        let result = await AXIOS("/log/getAllInterviewsInfo");
        if (result.success) {
            //this.allInterviewees = result.data.allInterviewees;
            this.allCreators = result.data.allCreators;
            this.allTypes = result.data.allTypes;
        } else {
            this.errMsg = result.errMsg;
        }
        this.getInterviewList(1);
    },
    methods: {
        selectCreator() {
            this.status = null;
            this.type = null;
            this.interviewee = null;
            this.getInterviewList(1)
        },
        selectType() {
            this.status = null;
            this.creator = null;
            this.interviewee = null;
            this.getInterviewList(1)
        },
        selectInterviewee() {
            this.status = null;
            this.type = null;
            this.creator = null;
            this.getInterviewList(1)
        },
        selectStatus() {
            this.type = null;
            this.creator = null;
            this.interviewee = null;
            this.getInterviewList(1)
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getInterviewList(1);
        },
        async getInterviewList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            if (this.status) data["status"] = this.status;
            if (this.type)  data["type"] = this.type;
            if (this.interviewee) data["interviewee"] = this.interviewee;
            if (this.creator) data["creator"] = this.creator;
            if (this.$route.query && this.$route.query.action)
                data["action"] = this.$route.query.action;
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }

            let result = await AXIOS("/log/allInterviewList", data);
            if (result.success) {
                this.interviewList = result.data.list;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        },
        deleteInterview(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this interview?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/log/deleteInterview", {code : code});
                if (result.success) {
                    this.interviewList.splice(this.interviewList.findIndex(e => e.idMD5 == code), 1);
                    ElMessage({
                        message: 'Deleted interview successfully!', type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg, type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>
    .label {padding-left:20px;}
</style>